var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.7998,
    y: 9.46808,
    width: 2,
    height: 7.45146,
    rx: 1,
    transform: "rotate(-45 3.7998 9.46808)",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1953,
    y: 5.771,
    width: 2,
    height: 10.6799,
    rx: 1,
    transform: "rotate(45 15.1953 5.771)",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default ForwardRef;